import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { ListItem, ListItemDivider, ListItemHeader, ListItemDropdown, BtnToggle } from '../../atoms';
import BtnWithDropdown from '../btn-with-dropdown';
import IconWithDropdown from '../icon-with-dropdown';
import { useDataExports } from '../../../hooks';
import styles from './exportBtnPDF.module.scss';
import { useI18N } from '../../../hooks';

interface Props {
    iconOnly?: boolean;
    small?: boolean;
    large?: boolean;
    className?: string;
    label?: string;
    data: any[];
    fields: {
        field: string;
        label?: string;
        [key: string]: any;
    }[];
    options?: {
        label: string,
        onClick: () => void;
    }[];
    onExport?: () => void;
    disabled?: boolean;
}
export default function ExportBtnPDF({ iconOnly, small, large, className, label, data, fields, options, onExport: onExportFN, disabled }: Props) {
    const i18n = useI18N();
    const { exportToPDF } = useDataExports();
    const size = (small) ? 'sm' : (large) ? 'lg' : undefined;
    const btnLabel = (label) ? label : i18n.translateThis('Export PDF', i18n.localize.exportBtnPDF.exportPdf);
    const onExport = () => {
        if (onExportFN) {
            onExportFN();
        }
        setTimeout(() => {
            exportToPDF(data, fields);
        }, 2000);
    }


    return (
        <>
            {
                (iconOnly) ?
                    (options) ?
                        <IconWithDropdown
                            icon={<i className={`fas fa-file-pdf text-danger ${styles.iconOnly}`} style={{ opacity: (disabled) ? .50 : 1 }}></i>}
                            className={`${className}`}
                            classNameToggle={'pt-0 pr-2'}
                            caret
                            drop={'down'}
                            text={btnLabel}
                            toolTip={false}
                            disabled={disabled}
                        >
                            <>
                                <ListItemHeader text={btnLabel} />
                                <ListItemDivider />
                                {
                                    options.map(({ label, onClick }, index) => (
                                        <ListItem
                                            key={index}
                                            text={label}
                                            onClick={onClick}
                                        />
                                    ))
                                }
                            </>
                        </IconWithDropdown> :
                        <i
                            className={`fas fa-file-pdf text-danger cursor ${styles.iconOnly} ${className}`}
                            onClick={onExport}
                        ></i> :
                    (options) ?
                        <BtnWithDropdown
                            small={(size === 'sm') ? true : false}
                            large={(size === 'lg') ? true : false}
                            variant={'danger'}
                            label={btnLabel}
                            className={className}
                            icon={<i className="fas fa-file-pdf text-white"></i>}
                            caret
                            caretDir={'down'}
                            disabled={disabled}
                        >
                            <>
                                <ListItemHeader text={btnLabel} />
                                <ListItemDivider />
                                {
                                    options.map(({ label, onClick }, index) => (
                                        <ListItem
                                            key={index}
                                            text={label}
                                            onClick={onClick}
                                        />
                                    ))
                                }
                            </>
                        </BtnWithDropdown> :
                        <Button
                            variant={'danger'}
                            size={size}
                            className={className}
                            onClick={onExport}
                            disabled={disabled}
                        >
                            <i className="fas fa-file-pdf text-white pr-2"></i>
                            {btnLabel}
                        </Button>
            }
        </>
    )
}